module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "l-container"
  }, [_c('router-view')], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-58f1b412"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Pages/Print/Print.vue
// module id = 1381
// module chunks = 0